const isSchemaV1 = (formData) => formData?.info?._schema_version !== 2;

export const isLegacyClosestSettlementView = (formData) => isSchemaV1(formData);

export const isLegacyContaminationView = (formData) => isSchemaV1(formData);

export const isLegacyDirectEvidenceView = (formData) => isSchemaV1(formData);

export const isLegacyIndirectEvidenceView = (formData) => isSchemaV1(formData);

export const shouldShowLegacyLandreleasePriority = (formData) => isSchemaV1(formData);

export const shouldShowLegacyLandreleaseClearanceDepth = (formData) => isSchemaV1(formData);

export const isLegacyLandreleaseView = (formData) => isSchemaV1(formData);

export const isLegacyLandWaterView = (formData) => isSchemaV1(formData);

export const isLegacyFieldMarkingView = (formData) => isSchemaV1(formData);
